// Core
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Box, Text, Image, Button, Center, Flex, useColorMode, Spinner } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';
import logo from 'assets/img/logo.png';

// Components
import ErrorCard from 'components/Form/Errors';

const Portal = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const [isLoading, setIsLoading] = useState(false);
  const [portalLink, setPortalLink] = useState();
  const [errorCard, setErrorCard] = useState();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hash = params.get('hash');

    if (hash) {
      setIsLoading(true);
      const fetchPortal = async () => {
        try {
          const response = await apiService.linkPortal({ hash });

          if (response.statusCode === 201) {
            window.location.href = response.data.url;
          } 

          setTimeout(() => {
            setIsLoading(false);

            if (response.statusCode === 201) {
              setPortalLink(response.data.url); 
            } else {
              setErrorCard(response.message);
            }
          }, 15000);
        } catch (e) {
          console.error('Failed to link portal:', e);
          setErrorCard(true);
        }
      };

      fetchPortal();
    }
  }, []);

  return (
    <Box>
      <Center>
        <Image src={logo} w="180px" />
      </Center>

      { isLoading &&
        <Center>
          <Spinner size="xl" mt="40px" />
        </Center>
      }

      { errorCard &&
        <Center>
          <Box p="0 10px">
            <ErrorCard error={errorCard} 
              mt="40px"
              maxW={{ base: '100%', md: '600px'}} 
              />
          </Box>
        </Center> 
      }

      { portalLink && 
        <Center p="0">
          <Box mt="40px" textAlign="center">
            <Text variant="text-md">Click the button if you`re not redirected automatically</Text>
            <Button 
              variant="button-md" 
              mt="16px" 
              as={'a'}
              href={portalLink}
              w={{base: '100%', sm: '300px'}}>Go to Link</Button> 
          </Box>
        </Center>
      }
    </Box>
  );
};

export default Portal;